import callAny from './call_any'
import { select } from 'redux-saga/effects'

import myLibraryUserDataSelector from 'redux/selectors/my_library/my_library_userData_selector'
import { myLibrarySync } from 'sync'

function *launchHomework(presentationUid, isNew, lms, validateCollaborate) {

	const userData = yield select(myLibraryUserDataSelector)
	const response = yield callAny(
		myLibrarySync.launchMyLibraryHomework,
		'ipad',
		presentationUid,
		'tabc',
		'',
		isNew,
		userData.jwt,
		lms,
		validateCollaborate,
	)

	return response
}

export default launchHomework
